import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import 'react-toggle/style.css';
import API from '../../utils/API';
import TabContainer from '../../components/views/TabsContainer';
import InputField from '../../components/inputs/inputField';
import ToggleField from '../../components/inputs/toggleField';
import SelectField from '../../components/inputs/selectField';
import SectionHeader from '../../components/views/SectionHeader';
import SectionFooter from '../../components/views/SectionFooter';
import PagePreviewFrame from '../../views/pages/components/pagePreviewFrame';
import FormBuilderModal from './modals/formBuilder';
import RichTextEditor from '../../views/pages/components/richTextEditor';
import ActionButtonContainer from '../../components/views/ActionButtonContainer';
import LoadingWizard from '../../components/spinner/wizard';
import moment from 'moment';

import DuplicateFormModal from './modals/duplicateFormModal';
import RenameFormModal from './modals/renameFormModal';
import CloseFormNowModal from './modals/closeFormNowModal';
import ScheduleCloseFormModal from './modals/scheduleCloseFormModal';
import DeleteFormModal from './modals/deleteFormModal';
import DeleteSubmissionModal from './modals/deleteSubmissionModal';
import FormSubmissions from './submissions';

const ENV =
	process.env.NODE_ENV === 'production'
		? window.location.href.includes('planner.simple.events') ? `https://admin-api.simple.events/` : `https://beta-api.simple.events/`
		: `http://${window.location.hostname}:5015/`;

const baseFieldList = [
	{
		_id: 'attendee',
		title: 'Contact Basic Detail Fields',
		fields: [
			{
				_id: '_firstName',
				fieldName: 'First Name',
				fieldType: 'text',
				required: true,
				propertyType: 'attendee'
			},
			{
				_id: '_lastName',
				fieldName: 'Last Name',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_email',
				fieldName: 'Email',
				fieldType: 'email',
				required: true,
				propertyType: 'attendee'
			},
			{
				_id: '_bcc',
				fieldName: 'BCC',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee',
			},
			{
				_id: '_phoneNumber',
				fieldName: 'Phone Number',
				fieldType: 'tel',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_title',
				fieldName: 'Title',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_company',
				fieldName: 'Company',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_textMessageOptIn',
				fieldName: 'Text Message Opt In',
				fieldType: 'checkbox',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_dietaryPreference',
				fieldName: 'Dietary Preference',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_foodAllergies',
				fieldName: 'Food Allergies',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_emergencyContactName',
				fieldName: 'Emergency Contact Name',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_emergencyContactPhoneNumber',
				fieldName: 'Emergency Contact Phone Number',
				fieldType: 'tel',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_address',
				fieldName: 'Address',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_address2',
				fieldName: 'Address 2',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_city',
				fieldName: 'City',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_state',
				fieldName: 'State',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_zip',
				fieldName: 'Zip',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_country',
				fieldName: 'Country',
				fieldType: 'text',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_profilePicture',
				fieldName: 'Profile Picture',
				fieldType: 'profileImage',
				required: false,
				propertyType: 'attendee'
			},
			{
				_id: '_NPINumber',
				fieldName: 'NPI Number',
				fieldType: 'NPINumber',
				required: false,
				propertyType: 'attendee'
			},
		]
	},
	{
		_id: 'special',
		title: 'Special Function Fields',
		fields: [
			{
				_id: '_additionalAttendees',
				fieldName: 'Additional Attendees',
				fieldType: 'additionalAttendees',
				propertyType: 'base',
				moduleConfiguration: {
					label: 'Guest',
					maxAttendees: 2,
					associatedGroup: null,
					defaultStatus: 'registered',
					confirmationEmail: null,
					fields: [
						{
							_id: '_firstName',
							attendeeField: { propertyType: 'base', propertyName: 'firstName' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeFirstName',
							label: 'First Name',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: true,
							style: '',
							type: 'text',
							static: true
						},
						{
							_id: '_lastName',
							attendeeField: { propertyType: 'base', propertyName: 'lastName' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeLastName',
							label: 'Last Name',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: false,
							style: '',
							type: 'text',
							static: false
						},
						{
							_id: '_email',
							attendeeField: { propertyType: 'base', propertyName: 'email' },
							columnClass: 'col-12',
							description: '',
							disabled: false,
							id: '_attendeeEmail',
							label: 'Email',
							objectClass: 'xbaseInput',
							options: [],
							placeholder: '',
							required: true,
							style: '',
							type: 'email',
							static: true
						}
					]
				}
			},
			{
				_id: '_medProLookup',
				fieldName: 'MedPro Lookup',
				fieldType: 'medProLookup',
				propertyType: 'base',
				moduleConfiguration: {
					"medProID": false,
					"medProMasterID": false,
					"firstName": false,
					"lastName": false,
					"suffix": false,
					"title": false,
					"address": false,
					"licenseNumber": false,
					"licenseState": false,
				}
			},
			{
				_id: '*notifierEmail',
				fieldName: 'Notifier Email',
				fieldType: 'notifierEmail',
				propertyType: 'custom',
				moduleConfiguration: { notificationEmail: null }
			},
			{
				_id: '*redirectToPage',
				fieldName: 'Redirect to Page',
				fieldType: 'redirectToPage',
				propertyType: 'custom',
				moduleConfiguration: {}
			},
		]
	}
];

class AccountForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			form: {},
			editedForm: {},
			formEditorModalOpen: false,
			customFields: (props.fields || []).map((category) => {
				const title = category.title;
				const headers = category.fields.map((field) => ({
					_id: field._id,
					fieldName: field.fieldName,
					fieldType: field.fieldType,
					category: title,
					categoryId: category._id,
					required: false,
					disabled: false,
					value: field.fieldName,
					label: field.fieldName,
					propertyType: 'attendee'
				}));
				return {
					_id: category._id,
					title,
					fields: headers,
					label: title,
					value: category._id,
					options: headers
				};
			}),
			metadataOptions: [],
			loading: true,
			editing: false,
			editingFormBuilder: false,
			currentPage: 0,
			selectedSection: 'settings',
			pageEmbedOptionsV2: [],
			selectedEmbedPage: 0,
			toggleAddToPage: false,
			toggleDuplicateFormModal: false,
			toggleRenameForm: false,
			toggleScheduleClose: false,
			toggleCloseNow: false,
			toggleDeleteForm: false,
			toggleDeleteSubmission: false,
			editingSubmissions: false,
			clearSubmissionsFunction: () => { },
			checkedSubmission: {},
			editCount: 0,
			isMissingFields: true,
			isV1: false,
			formFieldOptions: [],
			baseFieldList: [],
			tabs: [
				{ title: <span>Settings</span>, id: 'settings' },
				{ title: <span>Advanced</span>, id: 'advanced' },
				{ title: <span>Submissions</span>, id: 'submissions' },
			],
			contactCustomFields: []
		};
	}

	componentDidMount() {
		const { orgId, match: { params } } = this.props;
		console.log('Fetching form data for formId:', params.formId); // Debug log to check formId

		API().get(`Organizations/${orgId}/accountForms/${params.formId}`).then((res) => {
			if (res.data) {
				const editForm = JSON.parse(JSON.stringify({ ...this.state.editedForm, ...res.data.form }));
				if (!editForm.pages || editForm.pages.length === 0) {
					editForm.pages = [{
						title: '',
						description: '',
						sections: [{ _id: '^0', title: '', page: 1, fields: [], buttons: [] }]
					}];
				}

				let isMissingFields = true;
				const formFieldOptions = [];

				const attendeeBaseFields = baseFieldList.find(bfl => bfl._id === 'attendee');
				if (attendeeBaseFields) {
					attendeeBaseFields.fields.forEach(field => {
						formFieldOptions.push({
							label: `[${res.data.form.type === 'contactUpdate' ? 'Contact' : 'Attendee'}] ${field.fieldName}`,
							value: `attendee.${field._id.substring(1)}`,
							type: 'attendee'
						});
					});
				}

				(this.props.fields || []).forEach(category => {
					category.fields.forEach(field => {
						formFieldOptions.push({
							label: `[Custom] ${category.title} - ${field.fieldName}`,
							value: `custom.${field._id}`,
							type: 'custom'
						});
					});
				});

				if (editForm.pages && editForm.pages.length > 0) {
					for (let page of editForm.pages) {
						if (page.sections) {
							for (let section of page.sections) {
								if (section.fields && section.fields.length > 0) {
									section.fields.forEach(field => {
										formFieldOptions.push({
											label: `[Form] ${field.label}`,
											value: `form.${field.id || field._id}`,
											type: 'form'
										});
									});
									isMissingFields = false;
								}
							}
						}
					}
				}

				this.setState({
					isMissingFields,
					form: { ...this.state.form, ...res.data.form },
					contactCustomFields: res.data.contactCustomFields || [],
					editedForm: editForm,
					loading: false,
					pageEmbedOptionsV2: (editForm.pageEmbedOptionsV2 || []).map(option => ({
						label: option.title,
						value: option._id,
						partials: option.partials,
						url: option.url
					})),
					selectedEmbedPage: editForm.pageEmbedOptionsV2 && editForm.pageEmbedOptionsV2.length > 0
						? editForm.pageEmbedOptionsV2[0]._id : 0,
					formFieldOptions,
					baseFieldList: baseFieldList,
				}, () => {
					const selectedEmbedPagePreview = this.state.pageEmbedOptionsV2.find(
						o => o.value === this.state.selectedEmbedPage
					);
					this.setState({ selectedEmbedPagePreview });
				});
			}
		}).catch(() => this.setState({ loading: false }));
	}

	saveForm = async () => {
		const { orgId } = this.props;
		const { editedForm } = this.state;
		let editedFormTemp = JSON.parse(JSON.stringify(editedForm));
		if (editedForm.confirmationEmail === 'N/A' || editedForm.confirmationEmail === '') {
			delete editedFormTemp.confirmationEmail;
		}
		delete editedFormTemp.submissions;

		await API()
			.patch(`Organizations/${orgId}/accountForms/${editedForm._id}`, editedFormTemp)
			.then((res) => {
				if (res.data) {
					const editForm = JSON.parse(JSON.stringify({ ...this.state.editedForm, ...res.data }));
					let isMissingFields = true;
					if (editForm.pages) {
						for (let page of editForm.pages) {
							if (page.sections) {
								for (let section of page.sections) {
									if (section.fields && section.fields.length > 0) {
										isMissingFields = false;
										break;
									}
								}
							}
							if (!isMissingFields) break;
						}
					}
					this.setState({
						form: { ...this.state.editedForm, ...res.data },
						editedForm: editForm,
						editing: false,
						editingFormBuilder: false,
						editCount: this.state.editCount + 1,
						isMissingFields
					});
				}
			})
			.catch(() => this.setState({ invalid: true, submitting: false }));
	};

	deleteFormSubmission = async (callback) => {
		const { orgId } = this.props;
		const { form, editedForm, editingSubmissions, checkedSubmission } = this.state;
		if (editingSubmissions && Object.keys(checkedSubmission).length > 0) {
			await API()
				.patch(`Organizations/${orgId}/accountForms/${form._id}`, {
					deletedSubmissions: Object.keys(checkedSubmission)
				})
				.then((res) => {
					if (res.data) {
						const editForm = JSON.parse(JSON.stringify({ ...editedForm, ...res.data }));
						this.state.clearSubmissionsFunction();
						this.setState({
							form: { ...editedForm, ...res.data },
							editedForm: editForm,
							editing: false,
							editingFormBuilder: false,
							editCount: this.state.editCount + 1,
							checkedSubmission: {},
							editingSubmissions: false
						}, () => callback && callback());
					}
				})
				.catch(console.log);
		}
	};

	cancelSubmissionEdit = () => {
		if (this.state.editingSubmissions) {
			this.setState({ editingSubmissions: false, checkedSubmission: {} }, () => {
				this.state.clearSubmissionsFunction();
			});
		}
	};

	cancelEdit = () => {
		const revertedForm = JSON.parse(JSON.stringify(this.state.form));
		this.setState({ editedForm: revertedForm, editingFormBuilder: false, editing: false });
	};

	updateSelected = (selectedIndex, tabId) => {
		const revertedForm = JSON.parse(JSON.stringify(this.state.form));
		this.setState({
			editedForm: revertedForm,
			editing: false,
			selectedSection: tabId,
			checkedSubmission: {},
			editingSubmissions: false,
			clearSubmissionsFunction: () => { }
		});
	};

	removePage = (index) => {
		const { editedForm, currentPage } = this.state;
		editedForm.pages.splice(index, 1);
		const cp = currentPage > editedForm.pages.length - 1 ? editedForm.pages.length - 1 : currentPage;
		this.setState({ editedForm, currentPage: cp, editing: true });
	};

	updateForm = (editedForm) => {
		this.setState({ editedForm, editingFormBuilder: true });
	};

	handleChange = (changeObj) => {
		const { editedForm } = this.state;
		this.setState({ editedForm: { ...editedForm, ...changeObj }, editing: true });
	};

	toggleFormEditorModal = () => {
		this.setState({ formEditorModalOpen: !this.state.formEditorModalOpen });
	};

	updateFormName = (name, callback) => {
		const { editedForm, form } = this.state;
		this.setState({ editedForm: { ...editedForm, name }, form: { ...form, name } }, () => {
			callback && callback();
		});
	};

	toggleSubmissionEditing = (isEditing, checkedSubmission, clearSubmissionsFunction) => {
		this.setState({
			editingSubmissions: isEditing,
			checkedSubmission: checkedSubmission || {},
			clearSubmissionsFunction: clearSubmissionsFunction || (() => { })
		});
	};

	updateCustomFields = (customFieldData) => {
		const updatedCustomFields = [...this.state.customFields];
		const existingCategoryIndex = updatedCustomFields.findIndex(c => c.title === customFieldData.title);
		if (existingCategoryIndex > -1) {
			const lastField = customFieldData.fields[customFieldData.fields.length - 1];
			updatedCustomFields[existingCategoryIndex].fields.push({
				_id: lastField._id,
				fieldName: lastField.fieldName,
				fieldType: lastField.fieldType,
				required: false,
				disabled: false,
				propertyType: 'attendee'
			});
		} else {
			updatedCustomFields.push({
				_id: customFieldData._id || 'custom',
				title: customFieldData.title,
				fields: customFieldData.fields.map(f => ({
					_id: f._id,
					fieldName: f.fieldName,
					fieldType: f.fieldType,
					required: false,
					disabled: false,
					propertyType: 'attendee'
				}))
			});
		}
		this.setState({ customFields: updatedCustomFields });
	};

	updateCloseStatus = (properties, callback) => {
		const { form, editedForm } = this.state;
		this.setState(
			{ form: { ...form, ...properties }, editedForm: { ...editedForm, ...properties }, editCount: this.state.editCount + 1 },
			() => callback && callback()
		);
	};

	toggleDuplicateFormModal = () => this.setState({ toggleDuplicateFormModal: !this.state.toggleDuplicateFormModal });
	toggleRenameForm = () => this.setState({ toggleRenameForm: !this.state.toggleRenameForm });
	toggleScheduleClose = () => this.setState({ toggleScheduleClose: !this.state.toggleScheduleClose });
	toggleCloseNow = () => this.setState({ toggleCloseNow: !this.state.toggleCloseNow });
	toggleDeleteForm = () => this.setState({ toggleDeleteForm: !this.state.toggleDeleteForm });
	toggleDeleteSubmission = () => this.setState({ toggleDeleteSubmission: !this.state.toggleDeleteSubmission });

	renderSettingsSection = () => {
		const { editedForm, isMissingFields, pageEmbedOptionsV2, selectedEmbedPage } = this.state;
		const attendeeLabel = editedForm.type === 'contactUpdate' ? 'Contact' : 'Attendee';
		const { orgId } = this.props;
		const availableEmails = this.props.availableEmails || [];
		const selectedEmbedPagePreview = pageEmbedOptionsV2.find(o => o.value === selectedEmbedPage);

		const formTypes = [
			{ value: 'programRequest', label: 'Program Request' },
			{ value: 'contactUpdate', label: 'Contact Update' }
		];

		return (
			<div className='blocksContainer-Advanced'>
				<div className="sectionBlock mr-25 contained-form">
					<h2 className='blockHeader'>Basic Information</h2>
					<SelectField
						label="Form Type"
						type="select"
						required={true}
						value={formTypes.find(t => t.value === editedForm.type)}
						onChange={(e) => this.handleChange({ type: e.value })}
						options={formTypes}
					/>
					{editedForm.type === 'registration' && <ToggleField
						label="Allow Anonymous Submissions"
						checked={editedForm.allowAnonymous}
						icons={false}
						onChange={(e) => this.handleChange({ allowAnonymous: e.target.checked })}
					/>}
					{editedForm.type === 'registration' && <ToggleField
						label="Auto Login From Registration"
						checked={editedForm.autoLoginFromRegistration}
						icons={false}
						onChange={(e) => this.handleChange({ autoLoginFromRegistration: e.target.checked })}
					/>}
					{editedForm.type === 'registration' && <ToggleField
						label={`Limit to One Submission Per ${attendeeLabel}`}
						checked={editedForm.limitOneSubmission}
						icons={false}
						onChange={(e) => this.handleChange({ limitOneSubmission: e.target.checked })}
					/>}
					{editedForm.rsvpEnabled && <InputField
						label="Submit Button Label"
						required={false}
						placeholder="Register for Event"
						value={editedForm.rsvpLabel}
						onChange={(e) => this.handleChange({ rsvpLabel: e.target.value })}
					/>}
					<h2 className='blockHeader'>Submission</h2>
					<InputField
						label="Confirmation Page Title"
						required={false}
						placeholder="Form Submitted"
						value={editedForm.successTitle}
						onChange={(e) => this.handleChange({ successTitle: e.target.value })}
					/>
					<RichTextEditor
						id="Confirmation_Page_Description"
						label="Confirmation Page Description"
						placeholder="We have received your information"
						value={editedForm.successSubtitle}
						defaultHeight={5}
						onChange={(e) => this.handleChange({ successSubtitle: e })}
						customFields={this.state.metadataOptions}
					/>
					</div>
				<div style={{ padding: 5, minWidth: 490 }} className='sectionBlock contained-h emailDesignPreview mt-20'>
					<div
						style={{ width: 590, maxWidth: 'calc(100% - 15px)', minWidth: 'calc(100% - 700px)' }}
						className="cardDetailsContainerPages containerTitle"
					>
						<div className='w-100'>
							<h2 className='blockHeader mt-0'>Design</h2>
							<h5 className='formFieldLabel mt-10'>Form Preview</h5>
						</div>
						{!isMissingFields
							? <button className="neu ml-a" onClick={this.toggleFormEditorModal}>Edit Form</button>
							: <button className="neu prim ml-a" onClick={this.toggleFormEditorModal}>Add Form Fields</button>
						}
					</div>
					<div style={{ width: 590, maxWidth: 'calc(100% - 15px)', minWidth: 'calc(100% - 700px)', height: 500 }}>
						<div className="emailPreview eFrame pages flex-ac preview">
							<PagePreviewFrame
								ENV={ENV}
								key={this.state.editCount}
								renderURL={`Organizations/${orgId}/accountPages/render/formRender/`}
								pageProperties={{}}
								focusedComponent=""
								simulatedUser={{ value: this.props.account._id }}
								simulatedSession={{ value: false }}
								renderOnly={true}
								formId={editedForm._id}
								preview={true}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderAdvancedSection = () => {
		const { editedForm, isMissingFields } = this.state;
		const { orgId } = this.props;
		const attendeeLabel = editedForm.type === 'contactUpdate' ? 'Contact' : 'Attendee';

		return (
			<div className='blocksContainer-Advanced'>
				<div className="sectionBlock mr-25 contained-Advanced">
					<h2 className='blockHeader'>Form Information</h2>
					<ToggleField
						label={`Pre-fill form with ${attendeeLabel.toLowerCase()} data`}
						checked={editedForm.preFillAttendeeData}
						icons={false}
						onChange={(e) => this.handleChange({ preFillAttendeeData: e.target.checked })}
					/>
					<ToggleField
						label="Show Progress Bar"
						checked={editedForm.progressBarEnabled}
						icons={false}
						onChange={(e) => this.handleChange({ progressBarEnabled: e.target.checked })}
					/>
					<ToggleField
						label="Enable a review page before form submission"
						checked={editedForm.enableSubmissionReview}
						icons={false}
						onChange={(e) => this.handleChange({ enableSubmissionReview: e.target.checked })}
					/>
					{editedForm.enableSubmissionReview && (
						<div>
							<InputField
								label="Review Page Title"
								required={false}
								placeholder="Please Review"
								value={editedForm.submissionReviewTitle}
								onChange={(e) => this.handleChange({ submissionReviewTitle: e.target.value })}
							/>
							<RichTextEditor
								id="Review_Page_Description"
								label="Review Page Description"
								placeholder="Look over your questions and go back if you need to edit."
								value={editedForm.submissionReviewSubtitle}
								onChange={(e) => this.handleChange({ submissionReviewSubtitle: e })}
								customFields={this.state.metadataOptions}
							/>
						</div>
					)}
					<ToggleField
						label="Enable Captcha"
						checked={editedForm.captchaEnabled}
						icons={false}
						onChange={(e) => this.handleChange({ captchaEnabled: e.target.checked })}
					/>
					<ToggleField
						label="Enable Address Validation"
						checked={editedForm.validateAddress}
						icons={false}
						alert="Full address must be collected in the form for validation to work. (Address, Address 2, City, State, Zip)"
						onChange={(e) => this.handleChange({ validateAddress: e.target.checked })}
					/>
					{editedForm.rsvpEnabled && (
						<>
							<h2 className='blockHeader'>Decline Attendance</h2>
							<ToggleField
								label={`Allow ${attendeeLabel.toLowerCase()}s to decline attendance`}
								checked={editedForm.denialEnabled}
								icons={false}
								onChange={(e) => this.handleChange({ denialEnabled: e.target.checked })}
							/>
						</>
					)}
					{editedForm.rsvpEnabled && editedForm.denialEnabled && (
						<div>
							<InputField
								label="Decline Button Label"
								required={false}
								placeholder="I am unable to attend"
								value={editedForm.declineLabel}
								onChange={(e) => this.handleChange({ declineLabel: e.target.value })}
							/>
							<InputField
								label="Decline Page Title"
								required={false}
								placeholder="Sorry we missed you"
								value={editedForm.declineTitle}
								onChange={(e) => this.handleChange({ declineTitle: e.target.value })}
							/>
							<RichTextEditor
								id="Decline_Page_Description"
								label="Decline Page Description"
								placeholder="Not attending"
								value={editedForm.declineSubtitle}
								onChange={(e) => this.handleChange({ declineSubtitle: e })}
								customFields={this.state.metadataOptions}
							/>
							<ToggleField
								label="Enable Decline Options"
								checked={editedForm.enableDeclineOptions}
								icons={false}
								onChange={(e) => this.handleChange({ enableDeclineOptions: e.target.checked })}
							/>
							{editedForm.enableDeclineOptions && (
								<div className="pb-20">
									<div className="formFieldLabel">Decline Options</div>
									{(editedForm.declineOptions || []).map((option, index) => (
										<div className='flex-ac' key={index}>
											<InputField
												label="Item"
												required={false}
												placeholder="Not attending"
												value={option}
												onChange={(e) => {
													editedForm.declineOptions[index] = e.target.value;
													this.handleChange({ declineOptions: editedForm.declineOptions });
												}}
											/>
											<i className='las la-times ml-10' onClick={() => {
												editedForm.declineOptions.splice(index, 1);
												this.handleChange({ declineOptions: editedForm.declineOptions });
											}} />
										</div>
									))}
									<div className="c-pointer flex jcc" onClick={() => {
										const options = [...(editedForm.declineOptions || []), ''];
										this.handleChange({ declineOptions: options });
									}}>+ Add Decline Options</div>
								</div>
							)}
							<ToggleField
								label="Require Decline Options"
								checked={editedForm.requireDeclineOptions}
								icons={false}
								onChange={(e) => this.handleChange({ requireDeclineOptions: e.target.checked })}
							/>
							<ToggleField
								label="Include Decline Comment"
								checked={editedForm.enableDeclineComment}
								icons={false}
								onChange={(e) => this.handleChange({ enableDeclineComment: e.target.checked })}
							/>
							{editedForm.enableDeclineComment && (
								<ToggleField
									label="Require Decline Comment"
									checked={editedForm.requireComment}
									icons={false}
									onChange={(e) => this.handleChange({ requireComment: e.target.checked })}
								/>
							)}
						</div>
					)}
					{editedForm.type === 'general' && (
						<>
							<ToggleField
								label="Limit Submissions"
								checked={editedForm.limitSubmissionsEnabled}
								icons={false}
								onChange={(e) => this.handleChange({ limitSubmissionsEnabled: e.target.checked })}
							/>
							{editedForm.limitSubmissionsEnabled && (
								<>
									<h2 className='blockHeader'>Capacity</h2>
									<InputField
										label="Maximum Submissions Allowed"
										type="number"
										required={false}
										placeholder="Enter maximum number of submissions"
										value={editedForm.limitSubmissions ?? 0}
										min={0}
										onChange={(e) => {
											const val = parseInt(e.target.value);
											this.handleChange({ limitSubmissions: isNaN(val) || val < 0 ? 0 : val });
										}}
									/>
									<RichTextEditor
										id="Max_Capacity_Title"
										label="Max Capacity Title"
										placeholder="Registration is at capacity"
										value={editedForm.maxCapTitle}
										onChange={(e) => this.handleChange({ maxCapTitle: e })}
										customFields={this.state.metadataOptions}
									/>
									<RichTextEditor
										id="Max_Capacity_Message"
										label="Max Capacity Message"
										placeholder="This registration has reached capacity"
										value={editedForm.maxCapacityMessage}
										onChange={(e) => this.handleChange({ maxCapacityMessage: e })}
										customFields={this.state.metadataOptions}
									/>
								</>
							)}
						</>
					)}
					<h2 className='blockHeader'>Form Messages</h2>
					<InputField
						label="Form Closed Title"
						required={false}
						placeholder="Form unavailable"
						value={editedForm.formClosedTitle}
						onChange={(e) => this.handleChange({ formClosedTitle: e.target.value })}
					/>
					<InputField
						label="Form Closed Message"
						required={false}
						placeholder="This form is not currently available, check back at a later time or reach out to support."
						value={editedForm.formClosedMessage}
						onChange={(e) => this.handleChange({ formClosedMessage: e.target.value })}
					/>
				</div>
				<div style={{ padding: 5, minWidth: 490 }} className='sectionBlock contained-h emailDesignPreview mt-20'>
					<div
						style={{ width: 590, maxWidth: 'calc(100% - 15px)', minWidth: 'calc(100% - 700px)' }}
						className="cardDetailsContainerPages containerTitle"
					>
						<div className='w-100'>
							<h2 className='blockHeader mt-0'>Design</h2>
							<h5 className='formFieldLabel mt-10'>Form Preview</h5>
						</div>
						{!isMissingFields
							? <button className="neu ml-a" onClick={this.toggleFormEditorModal}>Edit Form</button>
							: <button className="neu prim ml-a" onClick={this.toggleFormEditorModal}>Add Form Fields</button>
						}
					</div>
					<div style={{ width: 590, maxWidth: 'calc(100% - 15px)', minWidth: 'calc(100% - 700px)', height: 500 }}>
						<div className="emailPreview eFrame pages flex-ac preview">
							<PagePreviewFrame
								ENV={ENV}
								key={this.state.editCount}
								renderURL={`Organizations/${orgId}/accountPages/render/formRender/`}
								pageProperties={{}}
								focusedComponent=""
								simulatedUser={{ value: this.props.account._id }}
								simulatedSession={{ value: false }}
								renderOnly={true}
								formId={editedForm._id}
								preview={true}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	};

	renderSubmissionsSection = () => {
		const { editedForm, form, contactCustomFields } = this.state;

		return (
			<FormSubmissions
				editedForm={editedForm}
				form={form}
				contactCustomFields={contactCustomFields}
				toggleSubmissionEditing={this.toggleSubmissionEditing}
			/>
		);
	};

	renderSection = () => {
		const { selectedSection } = this.state;
		switch (selectedSection) {
			case 'settings': return this.renderSettingsSection();
			case 'advanced': return this.renderAdvancedSection();
			case 'submissions': return this.renderSubmissionsSection();
			default: return this.renderSettingsSection();
		}
	};

	render() {
		const {
			form,
			loading,
			selectedSection,
			editedForm,
			editing,
			editingFormBuilder,
			toggleDuplicateFormModal,
			toggleRenameForm,
			toggleScheduleClose,
			toggleCloseNow,
			toggleDeleteForm,
			toggleDeleteSubmission,
			tabs
		} = this.state;
		const { orgId } = this.props;

		const selectedDate = form.closeAt ? new Date(form.closeAt) : null;
		const currentTimeDate = new Date(moment().format('MM/DD/YYYY hh:mm a'));
		let isFormClosed = false;
		let formClosedMessage = '';
		if (form.closed) {
			isFormClosed = true;
			formClosedMessage = 'This Form has been closed';
		}
		if (form.closeAt) {
			if (selectedDate <= currentTimeDate) {
				isFormClosed = true;
				formClosedMessage = 'This form is now closed as of ' + moment(selectedDate).format('MM/DD/YYYY hh:mm a');
			} else {
				formClosedMessage = 'This form is scheduled to close on ' + moment(selectedDate).format('MM/DD/YYYY hh:mm a');
			}
		}

		const subActions = isFormClosed ? [
			{ label: <span><i className='las la-pen mr-10' />Rename Form</span>, onClick: this.toggleRenameForm },
			{ label: <span><i className='las la-copy mr-10' />Duplicate Form</span>, onClick: this.toggleDuplicateFormModal },
			{ label: <span><i className='las la-lock-open mr-10' />Open Form Now</span>, onClick: this.toggleCloseNow },
			{ label: <span><i className='las la-trash mr-10' />Delete Form</span>, onClick: this.toggleDeleteForm },
		] : [
			{ label: <span><i className='las la-pen mr-10' />Rename Form</span>, onClick: this.toggleRenameForm },
			{ label: <span><i className='las la-copy mr-10' />Duplicate Form</span>, onClick: this.toggleDuplicateFormModal },
			{ label: <span><i className='las la-lock mr-10' />Close Form Now</span>, onClick: this.toggleCloseNow },
			{
				label: <span><i className={`${!form.closeAt ? 'las la-calendar-plus' : 'las la-calendar-minus'} mr-10`} />{form.closeAt ? 'Unschedule Close Form' : 'Schedule Close Form'}</span>,
				onClick: this.toggleScheduleClose
			},
			{ label: <span><i className='las la-trash mr-10' />Delete Form</span>, onClick: this.toggleDeleteForm },
		];

		const currentForm = (this.props.forms || []).find(f => f._id === this.props.match.params.formId);

		return (
			<div className="sectionContainer pageContainer">
				<SectionHeader
					title={currentForm ? currentForm.name : editedForm.name}
					description="Build and manage this account form."
					breadcrumbs={[{ name: 'Account Forms' }]}
					subActions={subActions}
				>
					<TabContainer
						tabs={tabs}
						updateSelected={this.updateSelected}
						selectedIndex={tabs.findIndex(t => t.id === selectedSection)}
					/>
				</SectionHeader>

				{!loading && formClosedMessage && (
					<p className='ml-10 flex aic mt-20'>{formClosedMessage}</p>
				)}

				{!loading && <div className="sectionBody">{this.renderSection()}</div>}

				{!loading && (selectedSection !== 'submissions'
					? <SectionFooter
						updatedAt={form.updatedAt}
						saveEdit={this.saveForm}
						cancelEdit={this.cancelEdit}
						editing={editing}
						lastEditedBy={editedForm.lastEditedBy}
					/>
					: <ActionButtonContainer
						batchActions={[{
							type: 'button',
							label: 'Delete Submission',
							iconClass: 'las la-trash-alt',
							class: 'danger',
							onClick: this.toggleDeleteSubmission
						}]}
						checkedEntryCount={Object.keys(this.state.checkedSubmission).length}
						entriesLength={editedForm.submissions ? editedForm.submissions.length : 0}
						uncheckEntries={this.cancelSubmissionEdit}
					/>
				)}

				<FormBuilderModal
					isOpen={this.state.formEditorModalOpen}
					editing={editingFormBuilder}
					toggle={this.toggleFormEditorModal}
					form={form}
					editedForm={editedForm}
					fields={this.props.fields || []}
					baseFieldList={[...this.state.baseFieldList]}
					customFieldList={[...this.state.customFields]}
					links={{ get: '' }}
					updateForm={this.updateForm}
					cancelEdit={this.cancelEdit}
					emails={this.props.availableEmails || []}
					orgId={orgId}
					addNewField={this.props.addNewField}
					saveForm={this.saveForm}
					customFields={this.state.contactCustomFields}
					contactCustomFields={this.state.contactCustomFields}
					updateCustomFields={this.updateCustomFields}
				/>

				{toggleDeleteSubmission && (
					<DeleteSubmissionModal
						toggle={this.toggleDeleteSubmission}
						isOpen={toggleDeleteSubmission}
						deleteSubmission={this.deleteFormSubmission}
						selectedSubmissionCount={Object.keys(this.state.checkedSubmission).length}
					/>
				)}
				{toggleRenameForm && (
					<RenameFormModal
						toggle={this.toggleRenameForm}
						isOpen={toggleRenameForm}
						name={form.name}
						formId={form._id}
						form={editedForm}
						orgId={orgId}
						update={this.updateFormName}
					/>
				)}
				{toggleDuplicateFormModal && (
					<DuplicateFormModal
						toggle={this.toggleDuplicateFormModal}
						isOpen={toggleDuplicateFormModal}
						name={form.name}
						formId={form._id}
						orgId={orgId}
					/>
				)}
				{toggleCloseNow && (
					<CloseFormNowModal
						toggle={this.toggleCloseNow}
						isOpen={toggleCloseNow}
						formId={form._id}
						orgId={orgId}
						updateCloseStatus={this.updateCloseStatus}
						isFormClosed={isFormClosed}
					/>
				)}
				{toggleScheduleClose && (
					<ScheduleCloseFormModal
						toggle={this.toggleScheduleClose}
						isOpen={toggleScheduleClose}
						formId={form._id}
						orgId={orgId}
						isScheduled={form.closeAt}
						updateCloseStatus={this.updateCloseStatus}
					/>
				)}
				{toggleDeleteForm && (
					<DeleteFormModal
						isOpen={toggleDeleteForm}
						toggle={this.toggleDeleteForm}
						form={form}
						count={1}
						isMultiple={false}
						removeForm={this.props.deleteSingleForm}
					/>
				)}

				<LoadingWizard text="Loading Form" loading={loading} />
			</div>
		);
	}
}

export default withRouter(AccountForm);
